<button
  kendoButton
  (click)="moreFilter()"
  [look]="'outline'"
  class="hideInput k-text-uppercase uk-padding-remove filtre-margin"
>
  <ng-container *ngIf="!getMoreFilter; else moreFilterTemplate">
    Afficher les filtres
  </ng-container>
  <ng-template #moreFilterTemplate>
    Masquer les filtres
  </ng-template>
</button>

<div class="uk-margin-small-top" *ngIf="getMoreFilter">
  <div class="uk-grid uk-grid-small">
    <div *ngFor="let status of statut_session" class="listOfButton">
      <button
        (click)="selectStatut(status)"
        [togglable]="true"
        [ngClass]="status.couleur"
        [ngStyle]="{ backgroundColor: status.couleur }"
        kendoButton
        class="k-text-uppercase filterButton"
      >
        {{ status.libelle | uppercase }}
      </button>
    </div>
    <div *ngFor="let bouttonsup of bouttonsups" class="listOfButton">
      <button
        (click)="selectStatut(bouttonsup)"
        [togglable]="true"
        [ngClass]="bouttonsup.couleur"
        kendoButton
        class="k-text-uppercase filterButton"
      >
        {{ bouttonsup.libelle | uppercase }}
      </button>
    </div>
  </div>
</div>

<div class="uk-grid uk-grid-medium uk-width-4-5 uk-margin-top uk-margin-medium-bottom" *ngIf="getMoreFilter">
  <div>
    <p class="uk-margin-remove">Secteur :</p>
    <kendo-multiselect
      [filterable]="true"
      [data]="listSector"
      [textField]="'libelle'"
      [valueField]="'id'"
      style="width: 150px!important;"
      (valueChange)="getFilterSelector($event, 'secteur')"
      class="primary-border"
    >
    </kendo-multiselect>
  </div>

  <div>
    <p class="uk-margin-remove">Famille :</p>
    <kendo-multiselect
      [filterable]="true"
      [data]="listFamile"
      [textField]="'libelle'"
      [valueField]="'id'"
      style="width: 150px!important;"
      (valueChange)="getFilterSelector($event, 'famille')"
    >
    </kendo-multiselect>
  </div>

  <div>
    <p class="uk-margin-remove">Groupe :</p>
    <kendo-multiselect
      [filterable]="true"
      [data]="listGroup"
      [textField]="'libelle'"
      [valueField]="'id'"
      style="width: 150px!important;"
      (valueChange)="getFilterSelector($event, 'groupe')"
    >
    </kendo-multiselect>
  </div>

  <div>
    <p class="uk-margin-remove">Produit :</p>
    <kendo-multiselect
      [filterable]="true"
      [data]="listProduits"
      [textField]="'libelle'"
      [valueField]="'id'"
      style="width: 150px!important;"
      (valueChange)="getFilterSelector($event, 'produit')"
    >
    </kendo-multiselect>
  </div>

  <div>
    <p class="uk-margin-remove">Responsable administratif :</p>
    <kendo-multiselect
      [filterable]="true"
      [data]="listResponsableAdministratif"
      [textField]="'name'"
      [valueField]="'id'"
      style="width: 230px!important;"
      (valueChange)="getFilterSelector($event, 'responsableadministratif')"
    >
    </kendo-multiselect>
  </div>
</div>
